module.exports = __webpack_public_path__ + "img/clock.fbf17096.png";